<template>
  <div class="gen-page">
    <div class="gen-layout">
      <!-- Sidebar (1) -->
      <aside class="gen-sidebar">
        <div class="sidebar-top">
          <div class="sidebar-brand">标营Ai音乐</div>
          <div class="btn-new" :class="{ 'btn-disabled': messages.length === 0 }" @click="addSession">
            <svg t="1778119796155" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18867" width="20" height="20">
                <path d="M512 152.74c48.8 0 96.05 9.57 140.54 28.35 43.06 18.18 81.69 44.26 114.82 77.51 33.25 33.25 59.21 71.88 77.51 114.82 18.78 44.49 28.35 91.74 28.35 140.54s-9.57 96.05-28.35 140.54c-18.18 43.06-44.26 81.69-77.51 114.82-33.25 33.25-71.88 59.21-114.82 77.51-44.5 18.77-91.74 28.34-140.54 28.34s-96.05-9.57-140.54-28.35c-43.06-18.18-81.69-44.26-114.82-77.51-33.25-33.25-59.21-71.88-77.51-114.82-18.78-44.49-28.35-91.74-28.35-140.54s9.57-96.05 28.35-140.54c18.18-43.06 44.26-81.69 77.51-114.82 33.25-33.25 71.88-59.21 114.82-77.51 44.49-18.77 91.74-28.34 140.54-28.34m0-86.12c-247.11 0-447.33 200.22-447.33 447.33S264.89 961.29 512 961.29s447.33-200.22 447.33-447.33S759.11 66.62 512 66.62z" fill="#040000" p-id="18868"></path><path d="M510.81 726.23c-20.67 0-37.39-16.72-37.39-37.39V331.37c0-20.67 16.72-37.39 37.39-37.39s37.39 16.72 37.39 37.39v357.47c-0.01 20.67-16.73 37.39-37.39 37.39z" fill="#040000" p-id="18869"></path>
                <path d="M688.61 550.51H332.39c-20.67 0-37.39-16.72-37.39-37.39s16.72-37.39 37.39-37.39h356.22c20.67 0 37.39 16.72 37.39 37.39-0.01 20.67-16.73 37.39-37.39 37.39z" fill="#040000" p-id="18870"></path></svg>
            <span>新建</span>
          </div>
          <div class="session-list">
            <div class="session-history" v-if="sessions.length > 0">历史记录</div>
            <div
              v-for="(s, i) in sessions"
              :key="i"
              :class="['session-item', { active: activeIndex === i }]"
              @click="selectSession(i, s)"
            >
              <svg viewBox="0 0 24 24" width="15" height="15" class="sess-icon">
                <path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
              </svg>
              <span class="sess-title">{{ s.title }}</span>
            </div>
          </div>
        </div>
        <div class="sidebar-bottom">
          <!-- 未登录：注册/登录 -->
          <div v-if="!user" class="sidebar-auth">
            <!-- <button class="sidebar-auth-btn sidebar-register-btn" @click="handleAuth">注册</button> -->
            <button class="sidebar-auth-btn sidebar-login-btn" @click="handleAuth">登录</button>
          </div>
          <!-- 已登录：用户信息（无点击事件） -->
          <div v-else class="sidebar-user-info">
            <img :src="user.avatarurl || ''" class="sidebar-avatar" alt="" />
            <div class="sidebar-user-detail">
              <div class="sidebar-username">{{ user.nickname }}</div>
              <div class="sidebar-score">{{ user.score_balance }} 积分</div>
            </div>
          </div>
          <div class="btn-new" @click="clearSessions" v-if="sessions.length > 0">
            <img src="./img/clear_icon.png" class="sidebar-btn-icon" alt="" />
            <span>清除</span>
          </div>
          <!-- <div class="btn-new">
            <img src="./img/service.png" class="sidebar-btn-icon" alt="" />
            <span>联系客服</span>
          </div> -->
          <!-- 已登录：退出登录 -->
          <div v-if="user" class="btn-new btn-logout" @click="handleLogout">
            <svg viewBox="0 0 24 24" width="16" height="16">
              <path fill="currentColor" d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
            </svg>
            <span>退出登录</span>
          </div>
        </div>
      </aside>

      <!-- Main (9) -->
      <main class="gen-main" @click="closeAllDropdowns">
        <div class="main-center" :class="{ 'has-messages': messages.length > 0 }">
          <!-- 欢迎标题：无记录时显示 -->
          <h1 v-if="messages.length === 0" class="model-heading">标营Ai音乐</h1>

          <!-- 聊天记录滚动区：有记录时显示 -->
          <div v-if="messages.length > 0" class="chat-scroll" ref="chatScroll" @scroll.passive="handleChatScroll">
            <div v-if="sessionLoadingMore" class="history-loading">加载中...</div>
            <div v-for="(msg, i) in messages" :key="i" class="msg-item">
              <!-- {{ msg  }} -->
              <p class="msg-prompt">{{ msg.prompt }}</p>
              <div class="msg-meta">
                <div class="msg-tags">
                  <span class="msg-tag">{{ msg.model }}</span>
                  <span class="msg-tag" v-if="msg.style">{{ getStyleName(msg.style) }}</span>
                </div>
                <span class="msg-time">{{ msg.time }}</span>
              </div>
              <div v-if="msg.error" class="msg-error">生成失败，请重试</div>
              <template v-else>
                <div v-if="!msg.tracks || !msg.tracks.length" class="msg-loading">
                  <div class="loading-progress">
                    <div class="loading-fill" :style="{ width: (msg.progress || 0) + '%' }"></div>
                  </div>
                  <span class="loading-text">生成中 {{ msg.progress || 0 }}%</span>
                </div>
                <div v-else class="msg-tracks">
                  <div
                    v-for="(track, j) in msg.tracks"
                    :key="j"
                    :class="['music-track', { 'is-playing': currentTrack && currentTrack.url === track.url && isPlaying }]"
                    @click="togglePlay(track)"
                  >
                    <div class="track-cover" :style="{ background: track.cover || 'linear-gradient(135deg,#1a1a2e,#7b2ff7)' }">
                      <div class="track-play">
                        <svg v-if="!(currentTrack && currentTrack.url === track.url && isPlaying)" viewBox="0 0 24 24" width="20" height="20">
                          <path fill="rgba(255,255,255,0.9)" d="M8 5v14l11-7z"/>
                        </svg>
                        <svg v-else viewBox="0 0 24 24" width="20" height="20">
                          <path fill="rgba(255,255,255,0.9)" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                        </svg>
                      </div>
                    </div>
                    <div class="track-info">
                      <div class="track-title">{{ msg.prompt }}</div>
                      <div class="track-style" v-if="track.styleDesc">{{ getStyleName(track.styleDesc) }}</div>
                    </div>
                    <div :class="['track-wave', { 'wave-playing': currentTrack && currentTrack.url === track.url && isPlaying }]">
                      <div class="wave-bar-box">
                        <div class="wave-bar" v-for="b in 40" :key="b"></div>
                      </div>
                      <div class="ai-tips">标营Ai生成</div>

                    </div>
                    

                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- Input Card -->
          <div class="input-card">
            <textarea
              class="gen-textarea"
              v-model="inputText"
              placeholder="尽输入您的歌曲描述，比如一首关于田园爱情的歌，夏天的风。"
            ></textarea>
            <div class="input-bar">
              <div class="bar-left">
                <!-- Model Selector -->
                <div class="sel-btn model-sel" @click.stop="modelOpen = !modelOpen">
                  <span class="sel-text">{{ currentModel.label }}</span>
                  <svg viewBox="0 0 24 24" width="13" height="13" class="arrow-icon">
                    <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                  </svg>
                  <div class="drop-panel" v-show="modelOpen">
                    <div
                      v-for="m in models"
                      :key="m.value"
                      :class="['drop-item', { active: currentModel.value === m.value }]"
                      @click.stop="currentModel = m; modelOpen = false"
                    >{{ m.label }}</div>
                  </div>
                </div>

                <!-- Music Style Selector -->
                <div class="sel-btn param-sel" @click.stop="styleOpen = !styleOpen">
                  <svg viewBox="0 0 24 24" width="14" height="14" class="param-icon">
                    <path fill="currentColor" d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
                  </svg>
                  <span class="sel-text">{{ currentStyle.label }}</span>
                  <svg viewBox="0 0 24 24" width="13" height="13" class="arrow-icon">
                    <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                  </svg>
                  <div class="drop-panel" v-show="styleOpen">
                    <div
                      v-for="s in styles"
                      :key="s.value"
                      :class="['drop-item', { active: currentStyle.value === s.value }]"
                      @click.stop="currentStyle = s; styleOpen = false"
                    >{{ s.label }}</div>
                  </div>
                </div>
              </div>
              <div class="bar-right">
                <button
                  :class="['send-btn', { active: inputText.trim() && !generating }]"
                  :disabled="generating"
                  @click.stop="generate"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16">
                    <path fill="currentColor" d="M2 21l21-9L2 3v7l15 2-15 2v7z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- 优秀作品 -->
          <featured-works
            v-if="messages.length === 0"
            :cate-id="103"
          />
        </div>
        <div class="ai-tips">内容由AI生成，请注意甄别</div>
      </main>
    </div>

    <!-- 隐藏 audio 元素 -->
    <audio
      ref="audio"
      :src="currentTrack ? currentTrack.url : ''"
      @timeupdate="onTimeUpdate"
      @loadedmetadata="onLoadedMetadata"
      @ended="onAudioEnded"
      style="display:none"
    ></audio>

    <!-- 右下角迷你播放器 -->
    <div v-if="currentTrack" class="mini-player">
      <div class="mini-cover" :style="{ background: currentTrack.cover || 'linear-gradient(135deg,#1a1a2e,#7b2ff7)' }">
        <svg v-if="!isPlaying" viewBox="0 0 24 24" width="14" height="14"><path fill="#fff" d="M8 5v14l11-7z"/></svg>
        <svg v-else viewBox="0 0 24 24" width="14" height="14"><path fill="#fff" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>
      </div>
      <div class="mini-body">
        <div class="mini-title">{{ currentTrack.title }}</div>
        <div class="mini-progress" @click="seekTo">
          <div class="mini-fill" :style="{ width: duration ? (currentTime / duration * 100) + '%' : '0%' }"></div>
        </div>
        <div class="mini-times">
          <span>{{ formatTime(currentTime) }}</span>
          <span>{{ formatTime(duration) }}</span>
        </div>
      </div>
      <div class="mini-actions">
        <button class="mini-btn" @click="togglePlayCurrent" :title="isPlaying ? '暂停' : '播放'">
          <svg v-if="!isPlaying" viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M8 5v14l11-7z"/></svg>
          <svg v-else viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>
        </button>
        <button class="mini-btn" @click="downloadCurrentTrack" title="下载">
          <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z"/></svg>
        </button>
        <button class="mini-btn mini-btn-close" @click="stopPlayer" title="关闭">
          <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FeaturedWorks from '@/components/FeaturedWorks.vue';

const ALL_GALLERY = [
  { bg: 'linear-gradient(135deg, #f5e6c8 0%, #c8921a 100%)' },
  { bg: 'linear-gradient(135deg, #0d0d2b 0%, #2c2c6e 100%)' },
  { bg: 'linear-gradient(135deg, #ff6b6b 0%, #9b2eff 100%)' },
  { bg: 'linear-gradient(135deg, #050a1e 0%, #0a3a6b 50%, #2196F3 100%)' },
  { bg: 'linear-gradient(135deg, #051724 0%, #0d4a5c 50%, #00bcd4 100%)' },
  { bg: 'linear-gradient(135deg, #160a2e 0%, #4a148c 50%, #7b2ff7 100%)' },
  { bg: 'linear-gradient(135deg, #fce4ec 0%, #f48fb1 50%, #e91e63 100%)' },
  { bg: 'linear-gradient(135deg, #e0f2f1 0%, #80cbc4 50%, #009688 100%)' },
  { bg: 'linear-gradient(135deg, #fff8e1 0%, #ffca28 50%, #ff6f00 100%)' },
  { bg: 'linear-gradient(135deg, #e8f5e9 0%, #66bb6a 50%, #1b5e20 100%)' },
  { bg: 'linear-gradient(135deg, #e3f2fd 0%, #42a5f5 50%, #0d47a1 100%)' },
  { bg: 'linear-gradient(135deg, #fdf2f8 0%, #ec4899 50%, #7e22ce 100%)' },
];

export default {
  name: 'MusicGen',
  components: { FeaturedWorks },
  data() {
    return {
      inputText: '',
      sessions: [],
      activeIndex: -1,
      modelOpen: false,
      styleOpen: false,
      currentModel: { value: 84, label: 'volcengine-gensong' },
      currentStyle: { value: 'pop', label: '风格' },
      models: [
        { value: 84, label: 'volcengine-gensong' }
      ],
      styles: [
        { value: 'pop', label: '流行' },
        { value: 'classical', label: '古典' },
        { value: 'rock', label: '摇滚' },
        { value: 'electronic', label: '电子' },
        { value: 'jazz', label: '爵士' },
        { value: 'rnb', label: 'R&B' },
        { value: 'folk', label: '民谣' },
        { value: 'hiphop', label: '嘻哈' },
      ],
      gallery: [],
      messages: [],
      historyId: 0,
      generating: false,
      pollingTimers: {},
      sessionPage: 1,
      sessionPageSize: 10,
      sessionHasMore: false,
      sessionLoadingMore: false,
      currentTrack: null,
      isPlaying: false,
      currentTime: 0,
      duration: 0,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  created() {
    this.gallery = ALL_GALLERY.slice(0, 8);
    this.loadHistory();
  },
  beforeDestroy() {
    Object.values(this.pollingTimers).forEach(t => clearInterval(t));
  },
  methods: {
    getStyleName(styleId) {
      if (!styleId) return '';
      const style = this.styles.find(s => s.value === styleId || s.label === styleId);
      return style ? style.label : styleId;
    },
    createTrack(task, fallbackStyle) {
      const out = task.output_json || {};
      return {
        title: out.prompt || '音乐',
        styleDesc: task.style_option_id || out.style || fallbackStyle || '',
        cover: out.cover || 'linear-gradient(135deg,#1a1a2e,#7b2ff7)',
        url: out.cdn_url || out.url || '',
      };
    },
    normalizeTrack(track, fallbackStyle) {
      return {
        ...track,
        styleDesc: track.styleDesc || track.style || fallbackStyle || '',
      };
    },
    buildMessageFromGroup(group) {
      const first = group[0];
      const inputJson = first.input_json || {};
      const done = group.length > 0 && group.every(task => task.progress === 100);
      const failed = group.some(task => task.status === 3);
      const avgProgress = group.length
        ? Math.floor(group.reduce((sum, task) => sum + (task.progress || 0), 0) / group.length)
        : 0;
      const styleValue = first.style_option_id || inputJson.style || '';
      const tracks = [];
      if (done) {
        for (const task of group) {
          const out = task.output_json || {};
          if (Array.isArray(out.tracks)) {
            tracks.push(...out.tracks.map(track => this.normalizeTrack(track, task.style_option_id || styleValue)));
          } else if (out.prompt || out.url) {
            tracks.push(this.createTrack(task, styleValue));
          }
        }
      }
      return {
        pk_group_id: first.pk_group_id,
        tempId: (!done && !failed) ? `h_${first.pk_group_id}` : null,
        prompt: inputJson.prompt || inputJson.text || '',
        model: first.model_name || '',
        style: styleValue,
        time: this.formatAddTime(first.add_time),
        tracks,
        progress: done ? 100 : (failed ? 0 : avgProgress),
        error: failed,
      };
    },
    fetchSessionPage(historyId, page, options = {}) {
      const { prepend = false, scrollToBottom = false } = options;
      const scrollEl = this.$refs.chatScroll;
      const prevScrollHeight = prepend && scrollEl ? scrollEl.scrollHeight : 0;
      const prevScrollTop = prepend && scrollEl ? scrollEl.scrollTop : 0;

      return this.$http.get('/front/aipkai/algorithm/task/', {
        params: { history_id: historyId, page, size: this.sessionPageSize, status: 0 },
      }).then(res => {
        if (!res || !res.data) return;
        const rawGroups = res.data.item_list || [];
        const groups = rawGroups.slice().reverse();
        const nextMessages = groups.map(group => this.buildMessageFromGroup(group));

        this.messages = prepend ? [...nextMessages, ...this.messages] : nextMessages;
        this.sessionPage = page;
        this.sessionHasMore = rawGroups.length >= this.sessionPageSize;

        this.messages.forEach(msg => {
          if (msg.tempId && !this.pollingTimers[msg.tempId]) {
            this.pollTask(msg.pk_group_id, msg.tempId, historyId);
          }
        });

        this.$nextTick(() => {
          const el = this.$refs.chatScroll;
          if (!el) return;
          if (scrollToBottom) {
            el.scrollTop = el.scrollHeight;
            return;
          }
          if (prepend) {
            el.scrollTop = el.scrollHeight - prevScrollHeight + prevScrollTop;
          }
        });
      });
    },
    handleAuth() {
      if (this.$showLogin) {
        this.$showLogin();
      }
    },
    handleLogout() {
      this.$logout();
    },
    loadHistory() {
      this.$http.get('/front/aipkai/algorithm/history/', {
        params: { cate_id: 103, page: 1, size: 10 },
      }).then(res => {
        if (res && res.status === 200 && res.data) {
          const list = res.data.item_list || [];
          this.sessions = list.map(item => ({
            id: item.id,
            title: this.extractPrompt(item.message).slice(0, 16) || '音乐生成',
          }));
          if (this.sessions.length > 0) this.activeIndex = 0;
        }
      }).catch(() => {});
    },
    tryParseMessage(msg) {
      if (!msg) return {};
      try { return JSON.parse(msg); } catch (e) { return {}; }
    },
    extractPrompt(msg) {
      if (!msg) return '';
      try { return JSON.parse(msg).prompt || msg; } catch (e) { return msg; }
    },
    formatAddTime(ts) {
      if (!ts) return '';
      const d = typeof ts === 'number' ? new Date(ts * 1000) : new Date(ts);
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    addSession() {
      if (this.messages.length === 0) return;
      Object.values(this.pollingTimers).forEach(t => clearInterval(t));
      this.pollingTimers = {};
      this.messages = [];
      this.historyId = 0;
      this.activeIndex = -1;
    },
    clearSessions() {
      if (!this.user || !localStorage.getItem('token')) {
        this.$toast && this.$toast('请先登录');
        this.$showLogin();
        return;
      }
      if (this.sessions.length === 0) return;
      if (confirm('确定要清除所有记录？')) {
        this.$http.delete('/front/aipkai/algorithm/history/', {
          params: { cate_id: 103 },
        }).then(() => {
          this.sessions = [];
          this.messages = [];
          this.activeIndex = -1;
        }).catch(() => {
          this.$toast && this.$toast('清除失败，请稍后重试');
        });
      }
    },
    generate() {
      if (!this.inputText.trim() || this.generating) return;
      if (!this.user || !localStorage.getItem('token')) {
        this.$toast && this.$toast('请先登录');
        this.$showLogin();
        return;
      }
      this.generating = true;
      const prompt = this.inputText.trim();
      if ( 5 > prompt.length || prompt.length > 700) {
        this.$toast && this.$toast('提示词长度应该大于5且小于700');
        this.generating = false;
        return;
      }
      const pad = n => String(n).padStart(2, '0');
      const now = new Date();
      const timeStr = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
      const tempId = `t_${Date.now()}`;
      this.messages.push({
        tempId,
        pk_group_id: null,
        prompt,
        model: this.currentModel.label,
        style: this.currentStyle.value,
        time: timeStr,
        tracks: [],
        progress: 0,
        error: false,
      });
      this.inputText = '';
      this.$nextTick(() => {
        const el = this.$refs.chatScroll;
        if (el) el.scrollTop = el.scrollHeight;
      });
      this.$http.post('/front/aipkai/algorithm/task/', {
        model_ids: [this.currentModel.value],
        // parameters: { prompt, text: prompt },
        parameters: 
        {
            "model": "volcengine-gensong",
            "model_version": "v4.3",
            "prompt": prompt,
            "billing_type":"postpaid",
        },
        cate_id: 103,
        history_id: this.historyId,
        style_option_id: this.currentStyle.value,
        num: 2,
        is_public: 0,
        parent_id: 0,
        tool_id: 0,
        timbre_id: 0,
        user_file_ids: [],
      }).then(res => {
        this.generating = false;
        if (res && res.data) {
          this.$fetchUserProfile();
          const { pk_group_id, history_id } = res.data;
          if (!this.historyId) {
            this.historyId = history_id;
            this.sessions.unshift({ id: history_id, title: prompt.slice(0, 16) });
            this.activeIndex = 0;
          }
          const msg = this.messages.find(m => m.tempId === tempId);
          if (msg) { msg.pk_group_id = pk_group_id; msg.progress = 0; }
          this.pollTask(pk_group_id, tempId, history_id);
        } else {
          if (res.status == 402){
            this.$toast && this.$toast('请先登录');
            this.$showLogin()
          } else {
            this._removeTempMsg(tempId);
            let msg = res.message || '提交失败，请稍后重试'
            this.$toast && this.$toast(msg);
          }
          
        }
      }).catch((err) => {
        this.generating = false;
        this._removeTempMsg(tempId);
        let msg = err.message || '提交失败，请稍后重试'
        this.$toast && this.$toast(msg);
      });
    },
    _removeTempMsg(tempId) {
      const idx = this.messages.findIndex(m => m.tempId === tempId);
      if (idx !== -1) this.messages.splice(idx, 1);
    },
    pollTask(pk_group_id, tempId, historyId) {
      const timer = setInterval(() => {
        this.$http.get('/front/aipkai/algorithm/task/', {
          params: { history_id: historyId, page: 1, status: 0 },
        }).then(res => {
          if (!res || !res.data) return;
          const groups = res.data.item_list || [];
          const group = groups.find(g => g[0] && g[0].pk_group_id === pk_group_id);
          if (!group) return;
          const allDone = group.length > 0 && group.every(task => task.progress === 100);
          const hasFailed = group.some(task => task.status === 3);
          const avgProgress = group.length
            ? Math.floor(group.reduce((sum, task) => sum + (task.progress || 0), 0) / group.length)
            : 0;
          const msg = this.messages.find(m => m.tempId === tempId);
          if (!msg) { clearInterval(timer); delete this.pollingTimers[tempId]; return; }
          msg.progress = allDone ? 100 : avgProgress;
          if (allDone) {
            const tracks = [];
            for (const task of group) {
              const out = task.output_json || {};
              if (Array.isArray(out.tracks)) {
                tracks.push(...out.tracks.map(track => this.normalizeTrack(track, task.style_option_id || msg.style)));
              } else if (out.prompt || out.url) {
                tracks.push(this.createTrack(task, msg.style));
              }
            }
            msg.tracks = tracks;
            clearInterval(timer);
            delete this.pollingTimers[tempId];
            this.$nextTick(() => {
              const el = this.$refs.chatScroll;
              if (el) el.scrollTop = el.scrollHeight;
            });
          } else if (hasFailed) {
            msg.error = true;
            msg.progress = 0;
            clearInterval(timer);
            delete this.pollingTimers[tempId];
          }
        }).catch(() => {});
      }, 3000);
      this.pollingTimers[tempId] = timer;
    },
    selectSession(index, session) {
      Object.values(this.pollingTimers).forEach(t => clearInterval(t));
      this.pollingTimers = {};
      this.activeIndex = index;
      if (session.id) this.loadSession(session.id);
    },
    loadSession(historyId) {
      this.historyId = historyId;
      this.messages = [];
      this.sessionPage = 1;
      this.sessionHasMore = false;
      this.sessionLoadingMore = false;
      this.fetchSessionPage(historyId, 1, { scrollToBottom: true }).catch(() => {});
    },
    handleChatScroll() {
      const el = this.$refs.chatScroll;
      if (!el || this.sessionLoadingMore || !this.sessionHasMore || !this.historyId) return;
      if (el.scrollTop > 80) return;
      this.sessionLoadingMore = true;
      this.fetchSessionPage(this.historyId, this.sessionPage + 1, { prepend: true })
        .catch(() => {
          this.$toast && this.$toast('历史记录加载失败，请稍后重试');
        })
        .finally(() => {
          this.sessionLoadingMore = false;
        });
    },
    closeAllDropdowns() {
      this.modelOpen = false;
      this.styleOpen = false;
    },
    togglePlay(track) {
      if (!track.url) return;
      const audio = this.$refs.audio;
      if (this.currentTrack && this.currentTrack.url === track.url) {
        // 同一首曲子：切换播放/暂停
        if (this.isPlaying) {
          audio.pause();
          this.isPlaying = false;
        } else {
          audio.play();
          this.isPlaying = true;
        }
      } else {
        // 切换新曲子
        this.currentTrack = track;
        this.currentTime = 0;
        this.duration = 0;
        this.isPlaying = false;
        this.$nextTick(() => {
          audio.load();
          audio.play().then(() => { this.isPlaying = true; }).catch(() => {});
        });
      }
    },
    togglePlayCurrent() {
      if (!this.currentTrack) return;
      const audio = this.$refs.audio;
      if (this.isPlaying) {
        audio.pause();
        this.isPlaying = false;
      } else {
        audio.play().then(() => { this.isPlaying = true; }).catch(() => {});
      }
    },
    stopPlayer() {
      const audio = this.$refs.audio;
      audio.pause();
      this.isPlaying = false;
      this.currentTrack = null;
      this.currentTime = 0;
      this.duration = 0;
    },
    onTimeUpdate() {
      this.currentTime = this.$refs.audio ? this.$refs.audio.currentTime : 0;
    },
    onLoadedMetadata() {
      this.duration = this.$refs.audio ? this.$refs.audio.duration : 0;
    },
    onAudioEnded() {
      this.isPlaying = false;
      this.currentTime = 0;
    },
    seekTo(e) {
      const audio = this.$refs.audio;
      if (!audio || !this.duration) return;
      const rect = e.currentTarget.getBoundingClientRect();
      const ratio = (e.clientX - rect.left) / rect.width;
      audio.currentTime = ratio * this.duration;
    },
    formatTime(s) {
      if (!s || isNaN(s)) return '0:00';
      const m = Math.floor(s / 60);
      const sec = Math.floor(s % 60);
      return `${m}:${String(sec).padStart(2, '0')}`;
    },
    downloadCurrentTrack() {
      if (!this.currentTrack) return;
      const a = document.createElement('a');
      a.href = this.currentTrack.url;
      a.download = (this.currentTrack.title || 'music') + '.mp3';
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    shuffleGallery() {
      const shuffled = [...ALL_GALLERY].sort(() => Math.random() - 0.5);
      this.gallery = shuffled.slice(0, 8);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.ai-tips{
  text-align: center;
  color: #CFCFCF
}
.session-history{
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  // color: #E5E7EB;
  border-bottom: 1px solid #E5E7EB;
}
.gen-page {
  height: 100vh;
  display: flex;
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', sans-serif;
  overflow: hidden;

  .gen-layout {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  /* 侧栏 flex: 1 */
  .gen-sidebar {
    flex: 1.5;
    min-width: 0;
    border-right: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #F9FBFC;
    overflow: hidden;

    .sidebar-top {
      display: flex;
      flex-direction: column;
      padding: 16px 10px 8px;
      gap: 8px;
      overflow: hidden;
    }

    .sidebar-brand {
      font-size: 20px;
      font-weight: 600;
      font-style: italic;
      color: #111827;
      padding: 6px 4px 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    //   border-bottom: 1px solid #f3f4f6;
    }

    .btn-new {
      display: flex;
      align-items: center;
      gap: 7px;
      padding: 8px 12px;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      background-color: #fff;
      cursor: pointer;
      font-weight: 600;
      font-size: 13px;
      color: #374151;
      user-select: none;
      transition: background 0.15s;
      white-space: nowrap;
      overflow: hidden;

      &:hover { background: #f9fafb; }

      &.btn-disabled {
        opacity: 0.4;
        cursor: not-allowed;
        &:hover { background: #fff; }
      }

      .new-plus { flex-shrink: 0; }

      .sidebar-btn-icon {
        width: 20px;
        height: 20px;
        object-fit: contain;
        flex-shrink: 0;
        filter: brightness(0);
      }
    }

    .session-list {
      overflow-y: auto;
      flex: 1;

      .session-item {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 7px 8px;
        border-radius: 7px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 600;
        color: #6b7280;
        transition: background 0.15s;

        &:hover { background: #f9fafb; }
        &.active { background: #f3f4f6; color: #111827; }

        .sess-title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .sidebar-bottom {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 10px 10px 14px;

      .sidebar-auth {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .sidebar-auth-btn {
          width: 100%;
          height: 34px;
          font-size: 13px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 500;
          transition: opacity 0.15s;
        }

        .sidebar-register-btn {
          color: #111827;
          background: #fff;
          border: 1px solid #e5e7eb;
          &:hover { background: #f9fafb; }
        }

        .sidebar-login-btn {
          color: #fff;
          background: #111827;
          border: none;
          &:hover { opacity: 0.85; }
        }
      }

      .sidebar-user-info {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px;
        border-radius: 8px;
        background: #f3f4f6;

        .sidebar-avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
          background: #e5e7eb;
          flex-shrink: 0;
        }

        .sidebar-user-detail {
          flex: 1;
          min-width: 0;

          .sidebar-username {
            font-size: 13px;
            font-weight: 600;
            color: #111827;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .sidebar-score {
            font-size: 11px;
            color: #6b7280;
            margin-top: 2px;
          }
        }
      }

      .btn-logout {
        color: #ef4444;
        svg { flex-shrink: 0; }
        &:hover { background: #fff5f5; color: #ef4444; }
      }
    }
  }

  /* 主内容区 flex: 9 */
  .gen-main {
    flex: 8;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .main-topbar {
      flex-shrink: 0;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 24px;

      .header-auth {
        display: flex;
        gap: 8px;

        .btn-register {
          height: 34px;
          padding: 0 22px;
          font-size: 14px;
          color: #111827;
          background: #fff;
          border: 1px solid #111827;
          border-radius: 6px;
          cursor: pointer;
          transition: opacity 0.15s;
          &:hover { opacity: 0.75; }
        }

        .btn-login {
          height: 34px;
          padding: 0 22px;
          font-size: 14px;
          color: #fff;
          background: #111827;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: opacity 0.15s;
          &:hover { opacity: 0.8; }
        }
      }

      .user-info-bar {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        padding: 4px 10px 4px 4px;
        border-radius: 8px;
        transition: background 0.15s;
        user-select: none;

        &:hover { background: #f3f4f6; }

        .user-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          object-fit: cover;
          background: #e5e7eb;
          flex-shrink: 0;
        }

        .user-name {
          font-size: 13px;
          font-weight: 500;
          color: #111827;
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .user-score {
          font-size: 12px;
          color: #6b7280;
          white-space: nowrap;
        }

        .arrow-icon { color: #9ca3af; flex-shrink: 0; }

        .user-drop {
          position: absolute;
          top: calc(100% + 6px);
          right: 0;
          min-width: 120px;
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.1);
          z-index: 300;
          padding: 4px 0;

          .user-drop-item {
            padding: 9px 16px;
            font-size: 13px;
            color: #ef4444;
            cursor: pointer;
            transition: background 0.12s;
            &:hover { background: #fff5f5; }
          }
        }
      }
    }

    .main-center {
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 32px 24px;

      .model-heading {
        width: 100%;
        max-width: 780px;
        text-align: center;
        font-style: italic;
        font-size: 50px;
        font-weight: 700;
        color: #111827;
        margin: 0 0 24px;
        letter-spacing: 0.02em;
      }

      .input-card {
        width: 100%;
        max-width: 1000px;
        border: 1px solid #e5e7eb;
        border-radius: 5px;
        background: #fff;
        overflow: visible;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

        .gen-textarea {
          display: block;
          width: 100%;
          min-height: 110px;
          padding: 18px 18px 10px;
          border: none;
          outline: none;
          resize: none;
          font-size: 14px;
          line-height: 1.6;
          color: #374151;
          box-sizing: border-box;
          font-family: inherit;
          border-radius: 14px 14px 0 0;

          &::placeholder { color: #9ca3af; }
        }

        .input-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 14px;
          border-top: 1px solid #f3f4f6;

          .bar-left {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;

            .sel-btn {
              position: relative;
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 5px 10px;
              border: 1px solid #e5e7eb;
              border-radius: 7px;
              cursor: pointer;
              font-size: 13px;
              color: #374151;
              background: #fff;
              user-select: none;
              transition: background 0.15s;

              &:hover { background: #f9fafb; }

              .sel-text { white-space: nowrap; }
              .arrow-icon { color: #9ca3af; flex-shrink: 0; }
              .param-icon { color: #6b7280; flex-shrink: 0; }

              .drop-panel {
                position: absolute;
                bottom: calc(100% + 6px);
                left: 0;
                min-width: 140px;
                background: #fff;
                border: 1px solid #e5e7eb;
                border-radius: 10px;
                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
                z-index: 200;
                padding: 4px 0;

                .drop-item {
                  padding: 9px 14px;
                  font-size: 13px;
                  color: #374151;
                  cursor: pointer;
                  transition: background 0.12s;

                  &:hover { background: #f9fafb; }
                  &.active { color: #2563eb; font-weight: 500; }
                }
              }
            }
          }

          .bar-right {
            .send-btn {
              width: 34px;
              height: 34px;
              border-radius: 50%;
              border: none;
              background: #d1d5db;
              color: #fff;
              cursor: default;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: background 0.2s;
              flex-shrink: 0;

              &.active {
                background: #111827;
                cursor: pointer;
                &:hover { background: #374151; }
              }

              svg { display: block; }
            }
          }
        }
      }

/* ─── 有消息时：覆盖布局行为 ─── */
      &.has-messages {
        justify-content: flex-start;
        overflow-y: hidden;
        padding: 0 24px 20px;
      }

      /* ─── 聊天滚动区 ─── */
      .chat-scroll {
        flex: 1;
        overflow-y: auto;
        width: 100%;
        max-width: 1000px;
        padding: 20px 0 8px;
        scrollbar-width: none;
        &::-webkit-scrollbar { display: none; }

        .history-loading {
          text-align: center;
          font-size: 12px;
          color: #9ca3af;
          padding: 4px 0 16px;
        }

        .msg-item {
          margin-bottom: 40px;
          padding-bottom: 40px;
          border-bottom: 1px solid #e5e7eb;

          .msg-prompt {
            font-size: 14px;
            color: #374151;
            line-height: 1.75;
            margin: 0 0 10px;
            word-break: break-all;
            white-space: pre-wrap;
          }

          .msg-meta {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 14px;
            padding: 10px 0;

            .msg-tags {
              display: flex;
              gap: 6px;
            }

            .msg-tag {
              padding: 2px 10px;
              background: #f3f4f6;
              border-radius: 4px;
              font-size: 12px;
              color: #6b7280;
            }

            .msg-time {
              font-size: 12px;
              color: #9ca3af;
            }
          }

          .msg-loading {
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 16px 0;

            .loading-progress {
              width: 100%;
              max-width: 400px;
              height: 6px;
              background: #f3f4f6;
              border-radius: 3px;
              overflow: hidden;

              .loading-fill {
                height: 100%;
                background: linear-gradient(90deg, #6366f1, #a855f7);
                border-radius: 3px;
                transition: width 0.5s ease;
              }
            }

            .loading-text {
              font-size: 13px;
              color: #9ca3af;
            }
          }

          .msg-error {
            font-size: 13px;
            color: #ef4444;
            padding: 12px 0;
          }

          .msg-tracks {
            display: flex;
            flex-direction: column;
            gap: 12px;

            .music-track {
              display: flex;
              align-items: center;
              gap: 14px;
              padding: 12px 16px;
              border: 1px solid #e5e7eb;
              border-radius: 10px;
              background: #fff;
              cursor: pointer;
              transition: box-shadow 0.15s;

              &:hover { box-shadow: 0 2px 12px rgba(0,0,0,0.08); }

              .track-cover {
                width: 56px;
                height: 56px;
                border-radius: 6px;
                flex-shrink: 0;
                display: flex;
                align-items: center;
                justify-content: center;

                .track-play {
                  width: 28px;
                  height: 28px;
                  border-radius: 50%;
                  background: rgba(0,0,0,0.35);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
              }

              .track-info {
                flex: 0 0 180px;
                min-width: 0;

                .track-title {
                  font-size: 14px;
                  font-weight: 600;
                  color: #111827;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-bottom: 4px;
                }

                .track-style {
                  font-size: 12px;
                  color: #9ca3af;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              .track-wave {
                flex: 1;
                display: flex;
                align-items: center;
                gap: 2px;
                height: 60px;
                flex-direction: column;

                .wave-bar-box{
                  width: 100%;
                  flex: 1;
                  display: flex;
                  align-items: center;
                  gap: 2px;
                  height: 60px;

                  .wave-bar {
                  flex: 1;
                  background: #d1d5db;
                  border-radius: 2px;
                  height: 25%;
                  transition: height 0.1s;

                  &:nth-child(2n)  { height: 40%; }
                  &:nth-child(3n)  { height: 65%; }
                  &:nth-child(5n)  { height: 85%; }
                  &:nth-child(7n)  { height: 50%; }
                  &:nth-child(11n) { height: 75%; }
                  &:nth-child(13n) { height: 55%; }
                  &:nth-child(17n) { height: 90%; }
                  &:nth-child(19n) { height: 35%; }
                }

                &.wave-playing .wave-bar {
                  background: linear-gradient(180deg, #6366f1, #a855f7);
                  animation: wave-dance 0.8s ease-in-out infinite alternate;

                  &:nth-child(2n)  { animation-delay: 0.1s; }
                  &:nth-child(3n)  { animation-delay: 0.2s; }
                  &:nth-child(5n)  { animation-delay: 0.15s; }
                  &:nth-child(7n)  { animation-delay: 0.3s; }
                  &:nth-child(11n) { animation-delay: 0.05s; }
                  &:nth-child(13n) { animation-delay: 0.25s; }
                  &:nth-child(17n) { animation-delay: 0.35s; }
                  &:nth-child(19n) { animation-delay: 0.12s; }
                }
                  
                }


              }
            }
          }
        }
      }

      .gallery-area {
        width: 100%;
        max-width: 1000px;
        margin-top: 18px;
        border: 1px solid #e5e7eb;
        border-radius: 5px;
        overflow: hidden;
        padding: 15px;

        .gallery-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;

          .gallery-label {
            font-size: 13px;
            color: #9ca3af;
          }

          .gallery-refresh {
            font-size: 13px;
            color: #9ca3af;
            cursor: pointer;
            transition: color 0.15s;
            &:hover { color: #374151; }
          }
        }

        .gallery-row {
          display: flex;
          gap: 8px;

          .gallery-cell {
            flex: 1;
            height: 100px;
            border-radius: 10px;
            overflow: hidden;
            cursor: pointer;
            transition: transform 0.15s, box-shadow 0.15s;

            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
            }
          }
        }
      }
    }
  }
}

@keyframes wave-dance {
  from { transform: scaleY(0.5); }
  to   { transform: scaleY(1.5); }
}

/* ══════════════════════════════
   右下角迷你播放器
══════════════════════════════ */
.mini-player {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 320px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  z-index: 500;

  .mini-cover {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mini-body {
    flex: 1;
    min-width: 0;

    .mini-title {
      font-size: 13px;
      font-weight: 600;
      color: #111827;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 6px;
    }

    .mini-progress {
      width: 100%;
      height: 4px;
      background: #e5e7eb;
      border-radius: 2px;
      cursor: pointer;
      margin-bottom: 3px;
      overflow: hidden;

      .mini-fill {
        height: 100%;
        background: linear-gradient(90deg, #6366f1, #a855f7);
        border-radius: 2px;
        transition: width 0.3s linear;
      }
    }

    .mini-times {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      color: #9ca3af;
    }
  }

  .mini-actions {
    display: flex;
    align-items: center;
    gap: 4px;

    .mini-btn {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      cursor: pointer;
      color: #374151;
      border-radius: 6px;
      transition: background 0.15s;

      &:hover { background: #f3f4f6; }
    }

    .mini-btn-close {
      color: #ef4444;
      &:hover { background: #fff5f5; }
    }
  }
}
</style>
